import VueScriptComponent from './components/VueScriptComponent.vue'
export default VueScriptComponent